import styled from 'styled-components';
import { colors, fontWeight } from '../../../theme';
import { ButtonStyled } from '../../../theme/style';

export const ColorSwatchContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 5px;
    flex-wrap: wrap;
`;

export const ColorSwatchTitleStyled = styled.h2`
    margin: 0;
    color: ${colors.grey100};
    font-weight: ${fontWeight.semiBold}
`;

export const ColorSwatchHeader = styled.div`
    margin-top: 34px;
`;

export const ColorSwatchSubTitle = styled.div`
    margin: 10px 0px;
`;

export const AddColorSwatchButtonStyled = styled(ButtonStyled)`
  && {
    color: ${colors.grey300};
    font-weight: ${fontWeight.bold};
    padding: 16px;
    max-height: 44px;
    max-width: 56px;
    margin-right: 0px;
    align-self: flex-end;
    margin-bottom: 8px;
    background-color: ${colors.grey800};
    span {
      margin-right: 0px;
    }
    &:hover {
        color: ${colors.defaultHover};
    }
    &:active {
        font-weight: ${fontWeight.bold};
    }
    @media print{
        display: none;
    }
  }
`;
